<template>
  <div :class="{'has-error': hasError}" class="card-panel">
    <span v-if="hasError" class="header-card-panel card-error-message paragraph">{{ errorMessage || defaultErrorMessage }} </span>

    <div v-if="$slots['header-name']"
         :class="{trimmed: trimmedHeaderName, separated: separatedHeader, 'is-uppercase': isUppercase}"
         class="header-card-panel paragraph-s paragraph-dark-gray paragraph-bold is-vcentered">
      <span class="header-container">
        <slot name="header-name"></slot>
        <slot name="header-counter"></slot>
      </span>
      <div v-if="removable" class="remove-icon" @click.stop="deleteCard">
        <slot name="remove-button">
          <svg-icon name="delete" class="delete-btn" width="16" height="16"></svg-icon>
        </slot>
      </div>
    </div>

    <div :class="{'paragraph': $mq.desktop, 'paragraph-s': !$mq.desktop, 'is-paddingless': paddinglessContent}"
         class="content-card-panel">
      <slot name="content"></slot>
    </div>
    <div v-if="$slots['info']" class="info-container">
      <slot name="info"></slot>
    </div>
    <div v-if="!!$slots['footer']" :class="{'borderless-footer': !separatedFooter}" class="card-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>

import '../../distribution/icons/delete';
export default {
  props: {
    paddinglessContent: Boolean,
    removable: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    errorMessage: String,
    trimmedHeaderName: {
      type: Boolean,
      default: false
    },
    separatedHeader: {
      type: Boolean,
      default: true
    },
    separatedFooter: {
      type: Boolean,
      default: false
    },
    isUppercase: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    defaultErrorMessage() {
      return this.$gettext('Please correct the errors below.');
    }
  },
  methods: {
    deleteCard() {
      this.$emit('delete-card');
    }
  }
};
</script>



<style lang="scss" scoped>
@import '~VariablesStyles';

.card-panel {
  background: var(--white);
  border-radius: 6px;
  box-shadow: 0 0 10px 0 var(--mid-gray);

  display: flex;
  flex-direction: column;

  .header-card-panel {
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;

    &.trimmed > *:first-child {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 93%;
    }
    &.separated {
      border-bottom: 1px solid var(--light-gray);
    }
  }
  .content-card-panel {
    padding: 20px;
  }
  .remove-icon {
    cursor: pointer;
    align-self: flex-start;

    /deep/ .svg-icon {
      stroke: var(--dark-gray);
    }
  }
  .card-error-message {
    color: var(--error);
  }

  .info-container {
    display: flex;
    flex-direction: column;
  }
  .card-footer {
    margin-top: auto;

    padding: 0 20px 20px 20px;
  }
}
.has-error {
  box-shadow: 0 0 10px 0 var(--error);
}

.borderless-footer {
  border: none;
}
</style>
